import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import './TextBlurb.scss';

const TextBlurb = (props) => {
  const { copy: { title, body }, className } = props;

  return (
    <div className={cx('TextBlurb', className)}>
      <h2>{title.value}</h2>
      <p>
        {body.value}
      </p>
    </div>
  );
};

TextBlurb.propTypes = {
  copy: PropTypes.shape({
    title: PropTypes.shape({
      value: PropTypes.string,
    }),
    body: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
  className: PropTypes.string,
};

TextBlurb.defaultProps = {
  copy: {
    title: {},
    body: {},
  },
  className: undefined,
};

TextBlurb.displayName = 'TextBlurb';
export default TextBlurb;
